@if (visible && imageReady) {
  <div class="logo" data-testid="logodiv">
    <img [ngSrc]="contentUrl" [alt]="altText" [width]="width" [height]="height"/>
  </div>
}
